import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "FormSubscribeNewsletter form-subscribe-newsletter" }

import { RequestError } from 'Api';
import BaseForm from 'Components/Base/BaseForm.vue';
import BaseFormInput from 'Components/Base/BaseFormInput.vue';
import BaseFormGroup from 'Components/Base/BaseFormGroup.vue';
import { BaseButton } from 'Components/Base/BaseButton';
import { useFormSubscribeNewsletter } from './composables/useFormSubscribeNewsletter';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormSubscribeNewsletter',
  setup(__props) {

const {
  FormBeforeSendError,
  isFormLoading,
  formValidation,
  formModel,
  formSend,
  formSendErrorMessage,
} = useFormSubscribeNewsletter();

async function send() {
  try {
    await formSend();
  } catch (error) {
    if (!(error instanceof FormBeforeSendError) && !(error as RequestError).handled) throw error;
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "is-h3__title form-subscribe-newsletter__title" }, " Subscribe to The Farmland Factor Newsletter ", -1)),
    _createVNode(BaseForm, {
      "send-loading": _unref(isFormLoading),
      class: "form-subscribe-newsletter__form"
    }, {
      default: _withCtx(({ isFormSendLoading }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["form-subscribe-newsletter__form-wrapper", { 'is--loading': isFormSendLoading }])
        }, [
          _createVNode(BaseFormGroup, {
            class: "form-subscribe-newsletter__form-group",
            validation: _unref(formValidation).email,
            "show-error": Boolean(_unref(formSendErrorMessage))
          }, {
            default: _withCtx(({ isFieldError }) => [
              _createVNode(BaseFormInput, {
                id: "subscribe_email",
                modelValue: _unref(formModel).data.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).data.email) = $event)),
                name: "email",
                label: "Email",
                placeholder: "Email Address",
                disabled: isFormSendLoading,
                "is-error": isFieldError,
                class: "form-subscribe-newsletter__input"
              }, null, 8, ["modelValue", "disabled", "is-error"])
            ]),
            error: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(formSendErrorMessage)), 1)
            ]),
            _: 2
          }, 1032, ["validation", "show-error"]),
          _createVNode(_unref(BaseButton), {
            disabled: isFormSendLoading,
            class: "form-subscribe-newsletter__button",
            type: "submit",
            color: "outlined-gray",
            large: "",
            loading: isFormSendLoading,
            onClick: _withModifiers(send, ["prevent"])
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createTextVNode(" Subscribe ")
            ])),
            _: 2
          }, 1032, ["disabled", "loading"])
        ], 2)
      ]),
      _: 1
    }, 8, ["send-loading"])
  ]))
}
}

})